// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-bar[data-v-ffbfdf76]{flex:0 0 auto;display:flex;align-items:center;border-bottom:1px solid rgba(0,0,0,.11)}\n/*  !*font: 11px Verdana, Arial, sans-serif;*!*/\n/*  !*background: rgb(247, 247, 247);*!*/\n/*  !*background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(247, 247, 247) 100%); !* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ *!*!*/\n\n/*  !* ensure debug toolbar text is displayed ltr even on rtl pages *!*/\n/*  !*background: rgb(247, 247, 247);*!*/", ""]);
// Exports
module.exports = exports;
